import React, { forwardRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

import { Bar } from 'react-chartjs-2'

import getReusableGraphOptions from '../reusableGraphOptions'

import { DEFAULT_GRAPH_COLOR } from '../../../../styles/themes/getDefaultTheme'

const BigBarGraph = forwardRef((props, ref) => {
  const { data, labels, className, graphColor, format, tooltipCallbackOptions } = props

  const theme = useTheme()

  const graphData = {
    labels,
    datasets: [
      {
        data: data,
        color: graphColor || theme[DEFAULT_GRAPH_COLOR],
        backgroundColor: graphColor || theme[DEFAULT_GRAPH_COLOR],
        borderColor: graphColor || theme[DEFAULT_GRAPH_COLOR],
        borderRadius: 4,
        borderSkipped: false,
        maxBarThickness: 34
      }
    ]
  }

  const graphOptions = useMemo(
    () => ({
      ...getReusableGraphOptions({ format, graphColor, theme, tooltipCallbackOptions }),
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false
          },
          ticks: {
            color: graphColor || theme[DEFAULT_GRAPH_COLOR],
            font: {
              size: 14
            },
            autoSkip: false
          }
        },
        y: {
          ...getReusableGraphOptions({}).scales.y
        }
      },
      padding: '0'
    }),
    [format, graphColor, theme, tooltipCallbackOptions]
  )

  return (
    <div className={className}>
      <Bar type="bar" data={graphData} options={graphOptions} ref={ref} />
    </div>
  )
})

BigBarGraph.propTypes = {
  data: PropTypes.array.isRequired,
  labels: PropTypes.array,
  className: PropTypes.string,
  graphColor: PropTypes.string,
  format: PropTypes.string,
  tooltipCallbackOptions: PropTypes.object
}

export default BigBarGraph
